import {Component, input} from '@angular/core';
import {IonLabel, IonSpinner} from '@ionic/angular/standalone';

/**
 * Komponente, welche die volle Fläche der Elternkomponente verdeckt und einen Loading-Spinner anzeigt
 * - Optionaler Text, der unter dem Spinner angezeigt wird
 */
@Component({
  selector: 'mits-loading-spinner',
  templateUrl: './mits-loading-spinner.component.html',
  styleUrls: ['./mits-loading-spinner.component.scss'],
  standalone: true,
  imports: [
    IonSpinner, IonLabel
  ]
})
export class LoadingSpinnerComponent {
  // Optionaler Text, der unter dem Spinner angezeigt wird
  readonly text = input('');
}
